<template>
  <div class="chart-container" style="position: relative; height: 400px; width: 100%; padding-top: 20px;">
    <!-- ใส่ :plugins เข้าไปที่นี่ -->
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

// ลงทะเบียน Chart.js Components
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

// รับค่าข้อมูลจาก Parent Component
const props = defineProps({
  transactions: {
    type: Array,
    required: true,
    default: () => []
  }
})

// --- ส่วนหัวใจหลัก: การทำ Data Transformation แบบ Dynamic ---
const chartData = computed(() => {
  // 1. ดึงช่วงเวลา (Labels) ทั้งหมดที่มีในข้อมูลมาเรียงลำดับ
  const allTimes = [...new Set(props.transactions.map(item => item.time.substring(0, 5)))].sort()

  // 2. กำหนดประเภทธุรกรรมและสี (Matching กับ Key ใน JSON ของคุณ)
  const typeConfigs = [
    { key: 'PAWN',          label: 'จำนำ',    color: '#4A90E2' }, // สีน้ำเงิน
    { key: 'INTEREST',      label: 'ต่อดอก',  color: '#FF8A65' }, // สีส้ม
    { key: 'INC_PRINCIPLE', label: 'เพิ่มต้น',  color: '#66BB6A' }, // สีเขียว
    { key: 'DEC_PRINCIPLE', label: 'ลดต้น',   color: '#EF5350' }, // สีชมพูเข้ม/แดง
    { key: 'REDEEM',        label: 'ไถ่ถอน',  color: '#FBC02D' }  // สีเหลือง
  ]

  // 3. สร้าง Datasets โดยการ Map ข้อมูลเข้ากับช่วงเวลา
  const datasets = typeConfigs.map(config => ({
    label: config.label,
    backgroundColor: config.color,
    // สำหรับแต่ละช่วงเวลา ให้หาค่า total ของประเภทนั้นๆ
    data: allTimes.map(time => {
      const found = props.transactions.find(
        item => item.time.startsWith(time) && item.type === config.key
      )
      return found ? found.total : 0
    })
  }))

  return {
    labels: allTimes,
    datasets: datasets
  }
})

// การตั้งค่ากราฟให้เป็นแบบ Stacked ตามรูปต้นฉบับ
const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      stacked: true,
      grid: { display: false },
      border: { color: '#000', width: 2 }, // เส้นแกนสีดำหนาขึ้น
      ticks: {
        color: '#333',
        font: { size: 10 },
        autoSkip: false, // แสดงทุกชั่วโมง
        maxRotation: 0
      },
      title: {
        display: true,
        text: 'เวลา ▶', // เติมหัวลูกศรที่ชื่อแกน
        align: 'end',
        color: '#000',
        font: { weight: 'bold' }
      }
    },
    y: {
      stacked: true,
      beginAtZero: true,
      border: { color: '#000', width: 2 },
      grid: { display: true }, // ในรูปไม่มีเส้นตารางแนวนอน
      ticks: { display: true }, // ในรูปดูเหมือนจะไม่โชว์ตัวเลขที่แกน Y
      title: {
        display: true,
        text: 'จำนวนธุรกรรม ▶', // เติมหัวลูกศรที่ชื่อแกน
        align: 'end',
        color: '#000',
        font: { weight: 'bold' }
      }
    }
  },
  plugins: {
    // ปรับแต่ง Legend ให้เหมือนในรูป (ด้านล่าง)
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        padding: 20,
        font: { size: 12 }
      }
    }
  }
}
</script>